import { useContext, useEffect, useState } from "react"
import Spinner, { ToggleSpinner } from "../../components/spinner"
import { fetchResource } from "../../../methods/fetchResource"
import { UserContext } from "../../userContext"
import { useRef } from "react"
import { generateErrorMessage } from "../../../methods/generateErrorMessage"

export default function ResidencyForm({ id, name, residencyValid, applicantProgressData, setApplicantProgressData }) {
	const [message, setMessage] = useState("")
	const [socialSecurityControlled, setSocialSecurityControlled] = useState("")
	const [driverLicenseControlled, setDriverLicenseControlled] = useState("")
	const [updateDriverLicense, setUpdateDriverLicense] = useState(false)
	const [updateSocialSecurity, setUpdateSocialSecurity] = useState(false)
	const [completed, setCompleted] = useState(residencyValid)
	const cursorPositionSocial = useRef(0)
	const previousEventTargetValueLengthSocial = useRef(0)
	const cursorPositionDriver = useRef(0)
	const previousEventTargetValueLengthDriver = useRef(0)
	const userContext = useContext(UserContext)

	const dateOfBirthId = `dateOfBirth|${id}`
	const ssnId = `ssn|${id}`
	const driverLicenseNumberId = `drivers|${id}`
	const driverLicenseDateId = `driverLicenseDate|${id}`
	const submitButtonId = `submit|${id}`
	const messageId = `message|${id}`
	const spinnerId = `spinner|${id}`
	const consentId = `consentForStorage|${id}`
	const understandingId = `understanding|${id}`

	useEffect(() => {
		if (message === "") {
			document.getElementById(messageId).classList.add("d-none")
			return
		}

		document.getElementById(messageId).classList.remove("d-none")
	}, [message, messageId])

	async function onSubmit(event) {
		event.preventDefault()
		setProcessingVisuals()

		let dateOfBirth = document.getElementById(dateOfBirthId).value
		let driverLicense = document.getElementById(driverLicenseNumberId).value.replace(/-/g, "")
		let socialSecurity = document.getElementById(ssnId).value.replace(/-/g, "")
		let consentForPrefill = document.getElementById(consentId).checked
		let driverLicenseDate = document.getElementById(driverLicenseDateId).value

		let residencyCheck = await fetchResource("/api/residency", {
			dateOfBirth,
			socialSecurity,
			driverLicense,
			driverLicenseDate,
			parcelID: userContext.parcelID,
			id,
			consentForPrefill
		})

		if (!residencyCheck.success) {
			switch (residencyCheck.status) {
				case 20001:
				case 20002:
				case 20003:
				case 20004:
				case 20005:
				case 20006:
				case 20007:
					setMessageAndResetVisuals(residencyCheck.message)
					return
				default:
					setMessageAndResetVisuals(generateErrorMessage(residencyCheck.status))
					return
			}
		}

		setCompleted(true)

		let updatedApplicantProgress = { ...applicantProgressData }
		updatedApplicantProgress[id] = true
		setApplicantProgressData(updatedApplicantProgress)

		ToggleSpinner(spinnerId)
		return
	}

	function setProcessingVisuals() {
		document.getElementById(submitButtonId).style.display = "none"
		setMessage("")
		ToggleSpinner(spinnerId)
	}

	function setMessageAndResetVisuals(message) {
		document.getElementById(submitButtonId).style.display = "block"
		setMessage(message)
		//document.getElementById(spinnerId).scrollIntoView()
		ToggleSpinner(spinnerId)
	}

	function socialSecurityValidator(event) {
		fieldValidator(event, previousEventTargetValueLengthSocial, cursorPositionSocial, [3, 6], setSocialSecurityControlled, setUpdateSocialSecurity, /[^0-9]/g)
	}

	function driverLicenseValidator(event) {
		fieldValidator(event, previousEventTargetValueLengthDriver, cursorPositionDriver, [4, 8, 11, 15], setDriverLicenseControlled, setUpdateDriverLicense, /[^0-9^a-z^A-Z]/g)
	}

	function fieldValidator(event, previousEventTargetValueLength, cursorPosition, hyphenPositions, setControlled, setUpdate, regex) {
		if (event.target.value.length === 0) {
			cursorPosition.current = 0
			setControlled(event.target.value)
			setUpdate(true)
			return
		}

		let validatedString = event.target.value.replace(regex, "")
		validatedString = validatedString.toUpperCase()
		validatedString = insertHyphens(validatedString, hyphenPositions)

		updateCursorPosition(event, validatedString, cursorPosition, previousEventTargetValueLength)

		previousEventTargetValueLength.current = event.target.value.length

		setControlled(validatedString)
		setUpdate(true)
	}

	function insertHyphens(string, positions) {
		positions.forEach(position => {
			if (string.length > position) {
				string = `${string.slice(0, position)}-${string.slice(position)}`
			}
		})

		return string
	}

	function updateCursorPosition(event, validatedString, cursorPosition, previousEventTargetValueLength) {
		if (event.target.value.length < validatedString.length) {
			if (event.target.value.length === event.target.selectionStart) {
				cursorPosition.current = validatedString.length
			}
			else {
				cursorPosition.current = event.target.selectionStart
			}
		}
		else {
			if (event.target.value.length === validatedString.length) {
				if (event.target.value.length === event.target.selectionStart) {
					cursorPosition.current = event.target.selectionStart + 1
				}
				else {
					if (event.target.value.length > previousEventTargetValueLength.current) {
						let extra = event.target.value.length - previousEventTargetValueLength.current

						cursorPosition.current = event.target.selectionStart + extra - 1
					}
					else {
						cursorPosition.current = event.target.selectionStart
					}
				}
			}
			else {
				cursorPosition.current = event.target.selectionStart
			}
		}
	}

	useEffect(() => {
		if (updateSocialSecurity) {
			if (document.getElementById(ssnId)) {
				document.getElementById(ssnId).focus()
				document.getElementById(ssnId).setSelectionRange(cursorPositionSocial.current, cursorPositionSocial.current)
			}

			setUpdateSocialSecurity(false)
		}// eslint-disable-next-line
	}, [updateSocialSecurity])

	useEffect(() => {
		if (updateDriverLicense) {
			if (document.getElementById(driverLicenseNumberId)) {
				document.getElementById(driverLicenseNumberId).focus()
				document.getElementById(driverLicenseNumberId).setSelectionRange(cursorPositionDriver.current, cursorPositionDriver.current)
			}

			setUpdateDriverLicense(false)
		}// eslint-disable-next-line
	}, [updateDriverLicense])

	return (
		<form className="ResidencyForm" onSubmit={onSubmit}>
			<div className="ResidencyFormFields">
				{
					!completed ?
						<>
							<div className="d-flex gap-3">
								<p className="h5">Name:</p>
								<p>{name}</p>
							</div>
							<div className="d-flex gap-3 mb-2">
								<div className="input-group" style={{maxWidth: "400px"}}>
									<label
										htmlFor={dateOfBirthId}
										className="input-group-text justify-content-end"
										style={{width: "150px"}}
									>
										Date of Birth:
									</label>
									<input
										id={dateOfBirthId}
										type="date"
										required
										title="Date of Birth"
										className="form-control"
									/>
								</div>
								<div className="input-group" style={{maxWidth: "400px"}}>
									<label
										htmlFor={ssnId}
										className="input-group-text justify-content-end"
										style={{width: "200px"}}
									>
										Social Security Number:
									</label>
									<input
										id={ssnId}
										type="text"
										pattern="^[0-9]{3}-[0-9]{2}-[0-9]{4}$"
										onChange={socialSecurityValidator}
										value={socialSecurityControlled}
										required
										title="Enter your Social Security Number"
										placeholder="000-00-0000"
										maxLength="11"
										className="form-control"
									/>
								</div>
							</div>
							<div className="d-flex gap-3 mb-3">
								<div className="input-group" style={{maxWidth: "400px"}}>
									<label
										htmlFor={driverLicenseNumberId}
										className="input-group-text justify-content-end"
										style={{width: "150px"}}
									>
										Driver License:
									</label>
									<input
										id={driverLicenseNumberId}
										type="text"
										pattern="^[A-Z]{1}[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{3}-[0-9]{1}$"
										onChange={driverLicenseValidator}
										value={driverLicenseControlled}
										required
										title="Enter your Driver's License number"
										placeholder="X000-000-00-000-0"
										maxLength="17"
										className="form-control"
									/>
								</div>
								<div className="input-group" style={{maxWidth: "400px"}}>
									<label
										htmlFor={driverLicenseDateId}
										className="input-group-text justify-content-end"
										style={{width: "200px"}}
									>
										Driver License Issue Date:
									</label>
									<input
										id={driverLicenseDateId}
										type="date"
										required
										title="Driver License Issue Date"
										className="form-control"
									/>
								</div>
							</div>
							<div className="form-check">
								<input
									type="checkbox"
									id={consentId}
									className="form-check-input"
								/>
								<label htmlFor={consentId} className="form-check-text">
									I consent to having the information above used for pre-filling the forms I will need to complete for this exemptions application process. I understand that selecting this option is not required, but if I do not consent, then I will need to re-enter the above information into the forms provided.
								</label>
							</div>
							<div className="form-check mb-3">
								<input
									type="checkbox"
									required
									id={understandingId}
									className="form-check-input"
								/>
								<label htmlFor={understandingId} className="form-check-text">
									I understand that the Santa Rosa County Property Appraiser's Office must retain the above information for the purposes of verifying my elgibility to receive exemptions.
								</label>
							</div>
							<input
								type="submit"
								id={submitButtonId}
								value="Submit"
								className="btn btn-warning"
							/>
							<Spinner id={spinnerId} />
						</> :
						<p>
							Residency has been validated for {name}
						</p>
				}
				<h2 id={messageId} className={`bg-danger p-3 rounded mt-3 ${message === "" ? "" : ""}`}>
					<i className="fa-solid fa-circle-exclamation"></i> {message}
				</h2>
			</div>
		</form>
	)
}